import { Pipe, PipeTransform } from '@angular/core';
import { ITagModel, TagUtil } from '@libs/vc-core-lib';

/**
 * @description
 *
 * The `stringArrayToTags` pipe converts an array of strings of tags into an array of tags of ITagModel type.  If passed
 * undefined or null, will return an empty array.
 *
 * @usageNotes
 *
 * ```
 * {{ arrayOf | stringArrayToTags }}
 * ```
 *
 */

@Pipe({
    name: 'stringArrayToTags',
    standalone: true,
})
export class StringArrayToTagsPipe implements PipeTransform {
    transform(value: string[] | null): ITagModel[] {
        if (!value) {
            return [];
        }

        return TagUtil.convertArrayStringToTags(value);
    }
}
